






import { Component,Vue } from 'vue-property-decorator'
import { State,namespace } from 'vuex-class'

@Component
export default class App extends Vue {
  
}
